import React from 'react';
import { Header } from '@features/header/Header';

interface PhqStepScaffoldProps {
  children: React.ReactNode;
}

/**
 * Page chrome for the pre-questionnaire PHQ gate screen (the waiver) that
 * were previously centered modal overlays. It is the shared branded page frame —
 * the reused B2C `Header` (logo-only in W2 mode) + a `<main>` hosting the two-panel
 * `W2SelectionStepLayout` card — mirroring `W2Onboarding`'s frame and
 * `SelectionScaffold`, but WITHOUT the selection-specific `W2SelectionStepBar`
 * (that bar needs a selection `StepCell[]` model; the pre-flow gate has none).
 *
 * Terminal/error states keep their `W2Shell` card; authenticated variants opt
 * that shell into the same shared Header/logout chrome.
 */
export const PhqStepScaffold: React.FC<PhqStepScaffoldProps> = ({
  children,
}) => {
  return (
    <div className="mx-auto flex min-h-screen max-w-[1920px] flex-col gap-3.5 bg-background py-3.5 pb-6 lg:gap-6 lg:pt-5">
      <Header showW2Logout />
      <main className="flex flex-1 flex-col px-6 max-lg:px-4">{children}</main>
    </div>
  );
};

export default PhqStepScaffold;
